import videoConstants from '../constants';

export function video(state = {}, action) {
    switch (action.type) {
        case videoConstants.DEVICE_CHANGED:
            return {
                ...state,
                deviceId: action.deviceId
            };
        case videoConstants.MIRROR_CHANGED:
            return {
                ...state,
                isMirrored: action.isMirrored
            };
        default: return state;
    }
}